import React, { useEffect, useState } from "react";
import CustomModal from "../../CustomModal/CustomModal";
import { BackIcon, fileIcons } from "../Icons";
import BreadCrumb from "../Components/BreadCrumb";
import { formatPath, invokeGetApi, invokePostApi } from "../utils/utils";
import DataTable from "../Components/DataTable";
import { useAuth } from "../../../features/auth/AuthContext";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useFileActions } from "../hooks/useFileActions";
import Loader from "../Components/Loader";

const MoveFile = ({
  open = false,
  fileName = "",
  close,
  file,
  afterSubmit = null,
}) => {
  const FolderIcon = fileIcons?.["folder"];
  const defaultData = [
    { id: 1, name: "Courses" },
    { id: 2, name: "My Profile" },
  ];
  const [data, setData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [path, setPath] = useState([{ id: 0, name: "Repository" }]);
  const [currentFolder, setCurrentFolder] = useState({
    id: 0,
    name: "Repository",
  });

  const { token } = useAuth();
  const { moveFile, isMoving } = useFileActions({
    token,
    closeModal: handleClose,
  });

  function handleBreadCrumClick(folder, index) {
    const newPath = path.slice(0, index + 1);
    setPath(newPath);
    setCurrentFolder(folder);
  }

  const folderClick = (clickedFolder) => {
    getData(clickedFolder?.id);
    const newPath = {
      id: clickedFolder?.id,
      name: clickedFolder?.folder_name || clickedFolder?.name,
    };
    setPath((prev) => [...prev, newPath]);
    setCurrentFolder(newPath);
  };

  const getData = async (id = null) => {
    const params = {
      folder_id: id || currentFolder?.id,
      is_move: 1,
    };
    setLoading(true);
    const response = await invokeGetApi(
      token,
      "manual-upload/folder-contents/",
      params,
    );
    if (response?.status === 200 || response?.status === 201) {
      let newData = response?.data?.items?.filter(
        (item) => item?.item_type === "folder",
      );
      setData(newData);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (currentFolder?.id === 0) {
      setData(defaultData);
    } else {
      getData();
    }
  }, [currentFolder]);

  const columns = [
    {
      key: "folder_name",
      title: "Name",
      render: (val, row, idx) => {
        // console.log(row, "check");
        const FileIcon = fileIcons?.["folder"];
        return (
          <button
            className="border-none bg-transparent flex items-center gap-2"
            onClick={() => folderClick(row)}
          >
            <FileIcon />
            <span>{row?.name || val}</span>
          </button>
        );
      },
    },
  ];

  const handleSubmit = () => {
    moveFile(file, currentFolder?.id, handleClose);
  };

  function handleClose() {
    setPath([{ id: 0, name: "Repository" }]);
    setCurrentFolder({
      id: 0,
      name: "Repository",
    });
    close();
  }

  const handleGoBack = () => {
    if (path.length <= 1) return; // prevent removing root
    const newPath = path.slice(0, -1);
    setPath(newPath);
    setCurrentFolder(newPath[newPath.length - 1]);
    getData(newPath[newPath.length - 1]);
  };
  const filePath = formatPath(file?.full_path);
  return (
    <CustomModal
      open={open}
      isHeader={false}
      onClose={handleClose}
      childMT={0}
      primaryLabel={!isMoving ? "Move" : null}
      secondaryClick={handleClose}
      height={"80vh"}
      secondaryLabel={!isMoving ? "Cancel" : null}
      primaryDisbaled={
        currentFolder?.id === 1 || currentFolder?.id === 0 || isMoving
      }
      primaryClick={handleSubmit}
      justify={"space-between"}
    >
      <div
        title={`Move ${file?.file_name}`}
        className="text-[#232323] truncate max-w-[95%]"
      >
        {" "}
        Move {file?.file_name}
      </div>
      <hr />
      <div className="flex items-center gap-2 max-w-[90%]">
        <span className="text[#9A9D94] font-normal text-[0.8rem]">Source:</span>
        <div className="mx-2 flex gap-2 items-center min-w-full max-w-full">
          <FolderIcon />
          <span
            title={filePath}
            className="text-[#333333] font-medium text-[0.9rem] truncate max-w-[80%]"
          >
            {filePath}
          </span>
        </div>
      </div>
      {currentFolder?.id !== 0 && (
        <>
          <button
            className="border-none bg-transparent p-0 m-0 my-3 flex items-center gap-2"
            onClick={handleGoBack}
          >
            {/* <span> */}
            <BackIcon />
            {/* </span> */}
            <span className="text-[#232323] text-[0.9rem] font-medium">
              More Locations
            </span>
          </button>
          <BreadCrumb
            marginBottom="mb=0"
            marginTop="mt-0"
            path={path}
            onFolderClick={handleBreadCrumClick}
          />
        </>
      )}
      {isMoving || loading ? (
        <Loader />
      ) : (
        <>
          {data?.length > 0 ? (
            <DataTable
              columns={columns}
              dataSource={data}
              rowKey="key"
              emptyText="No Folders found"
              isMove={true}
              emptyHeadLabel="No Folders Found"
            />
          ) : (
            <div className="w-full flex flex-col items-center justify-center gap-2 h-[40vh]">
              <svg
                width="56"
                height="49"
                viewBox="0 0 56 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30.7002 41.2793C30.7003 41.4106 30.6745 41.5407 30.6242 41.6621C30.574 41.7834 30.5004 41.8937 30.4075 41.9866C30.3146 42.0794 30.2043 42.1531 30.083 42.2033C29.9616 42.2536 29.8315 42.2794 29.7002 42.2793H3.78027C2.77818 42.2782 1.81742 41.8797 1.10874 41.1712C0.400064 40.4627 0.00132873 39.5021 0 38.5V13.334C0 13.0688 0.105357 12.8144 0.292893 12.6269C0.48043 12.4394 0.734784 12.334 1 12.334C1.26522 12.334 1.51957 12.4394 1.70711 12.6269C1.89464 12.8144 2 13.0688 2 13.334V38.5C2.00064 38.9719 2.18844 39.4242 2.52219 39.7578C2.85595 40.0914 3.3084 40.2789 3.78027 40.2793H29.7002C29.8315 40.2792 29.9616 40.305 30.083 40.3553C30.2043 40.4055 30.3146 40.4792 30.4075 40.572C30.5003 40.6649 30.574 40.7752 30.6242 40.8965C30.6745 41.0179 30.7003 41.148 30.7002 41.2793ZM0 9.33399V3.7793C0.00132873 2.77721 0.400064 1.81655 1.10874 1.10806C1.81742 0.39956 2.77818 0.00107157 3.78027 0H17.6699C17.8556 2.13447e-05 18.0377 0.0517385 18.1957 0.149361C18.3537 0.246983 18.4813 0.386655 18.5644 0.55274L19.3292 2.08399H44.9814C45.983 2.08528 46.9432 2.4838 47.6513 3.19212C48.3595 3.90044 48.7578 4.86072 48.7588 5.86231V8.38367C49.6564 8.5119 50.4779 8.95894 51.0731 9.64305C51.6682 10.3272 51.9972 11.2026 52 12.1094V23.5098C52 23.775 51.8946 24.0293 51.7071 24.2169C51.5196 24.4044 51.2652 24.5098 51 24.5098C50.7348 24.5098 50.4804 24.4044 50.2929 24.2169C50.1054 24.0293 50 23.775 50 23.5098V12.1094C49.9994 11.6374 49.8116 11.1849 49.4779 10.8512C49.1442 10.5175 48.6917 10.3297 48.2197 10.3291H21.8301C21.6442 10.3292 21.462 10.2775 21.304 10.1796C21.1459 10.0818 21.0183 9.94181 20.9356 9.7754L17.0518 2H3.78027C3.3084 2.00038 2.85595 2.18794 2.5222 2.52151C2.18844 2.85508 2.00064 3.30743 2 3.7793V9.33399C2 9.59921 1.89464 9.85356 1.70711 10.0411C1.51957 10.2286 1.26522 10.334 1 10.334C0.734784 10.334 0.48043 10.2286 0.292893 10.0411C0.105357 9.85356 0 9.59921 0 9.33399ZM20.3281 4.08399L22.4482 8.32911H46.7588V5.86231C46.7584 5.39095 46.5711 4.93897 46.2379 4.60558C45.9047 4.27218 45.4528 4.0846 44.9814 4.08399H20.3281ZM56 36.7695C56 39.1429 55.2962 41.463 53.9776 43.4364C52.6591 45.4098 50.7849 46.9478 48.5922 47.8561C46.3995 48.7643 43.9867 49.002 41.6589 48.539C39.3311 48.0759 37.1929 46.9331 35.5147 45.2548C33.8365 43.5766 32.6936 41.4384 32.2306 39.1106C31.7676 36.7829 32.0052 34.3701 32.9134 32.1773C33.8217 29.9846 35.3598 28.1105 37.3332 26.7919C39.3065 25.4733 41.6266 24.7695 44 24.7695C47.1815 24.773 50.2318 26.0384 52.4814 28.2881C54.7311 30.5378 55.9965 33.588 56 36.7695ZM54 36.7695C54 34.7917 53.4135 32.8583 52.3147 31.2138C51.2159 29.5693 49.6541 28.2876 47.8268 27.5307C45.9996 26.7739 43.9889 26.5758 42.0491 26.9617C40.1093 27.3475 38.3275 28.2999 36.9289 29.6985C35.5304 31.097 34.578 32.8788 34.1921 34.8186C33.8063 36.7584 34.0043 38.7691 34.7612 40.5964C35.5181 42.4236 36.7998 43.9854 38.4443 45.0842C40.0888 46.1831 42.0222 46.7695 44 46.7695C46.6512 46.7664 49.1929 45.7119 51.0676 43.8372C52.9423 41.9625 53.9969 39.4207 54 36.7695ZM49.1074 31.6621C49.0146 31.5692 48.9044 31.4956 48.7831 31.4453C48.6617 31.395 48.5317 31.3691 48.4004 31.3691C48.2691 31.3691 48.139 31.395 48.0177 31.4453C47.8964 31.4956 47.7862 31.5692 47.6934 31.6621L44 35.3555L40.3066 31.6621C40.1191 31.4746 39.8648 31.3693 39.5996 31.3693C39.3344 31.3693 39.0801 31.4746 38.8926 31.6621C38.7051 31.8496 38.5997 32.104 38.5997 32.3691C38.5997 32.6343 38.7051 32.8887 38.8926 33.0762L42.5859 36.7695L38.8926 40.4629C38.7051 40.6504 38.5997 40.9047 38.5997 41.1699C38.5997 41.4351 38.7051 41.6894 38.8926 41.877C39.0801 42.0645 39.3344 42.1698 39.5996 42.1698C39.8648 42.1698 40.1191 42.0645 40.3066 41.877L44 38.1836L47.6934 41.877C47.8809 42.0645 48.1352 42.1698 48.4004 42.1698C48.6656 42.1698 48.9199 42.0645 49.1074 41.877C49.2949 41.6894 49.4003 41.4351 49.4003 41.1699C49.4003 40.9047 49.2949 40.6504 49.1074 40.4629L45.4141 36.7695L49.1074 33.0762C49.2003 32.9833 49.274 32.8731 49.3242 32.7518C49.3745 32.6305 49.4004 32.5005 49.4004 32.3691C49.4004 32.2378 49.3745 32.1078 49.3242 31.9865C49.274 31.8652 49.2003 31.7549 49.1074 31.6621Z"
                  fill="#0068FF"
                />
              </svg>
              <span className="text=[#949494] text-[0.9rem] font-normal">
                This folder is empty
              </span>
            </div>
          )}
        </>
      )}
    </CustomModal>
  );
};

export default MoveFile;
